// Regra da conta de QUIOSQUE (terminal de chão) — pura, sem IO nem React.
// O ProtectedRoute usa para TRANCAR a conta no posto dela; a raiz ("/") usa
// para mandar o terminal direto ao posto. Uma regra só, nos dois lugares.
import {
    KIOSK_ACCOUNT_PERMISSIONS,
    KIOSK_BENCH_MIN_WIDTH,
    KIOSK_BENCH_PATH,
    KIOSK_COLLECTOR_PATH,
    KIOSK_OPERATE_PERMISSION,
} from '../constants/kiosk';

/**
 * A conta é SÓ terminal? Precisa de `wms:operate` e de nada além do piso
 * (`profile:*`). O god-mode (`admin`, `developer`, `*`, `all:*`) fica de fora
 * por construção: não está no piso, então qualquer uma dessas chaves já
 * devolve `false`.
 */
export function IsKioskOnlyAccount(permissions) {
    if (!Array.isArray(permissions) || !permissions.includes(KIOSK_OPERATE_PERMISSION)) {
        return false;
    }
    return permissions.every((permission) => KIOSK_ACCOUNT_PERMISSIONS.includes(permission));
}

/** O posto pelo TAMANHO DA TELA: bancada a partir de 1024 px, coletor abaixo. */
export function KioskHomePath(width) {
    return Number(width) >= KIOSK_BENCH_MIN_WIDTH ? KIOSK_BENCH_PATH : KIOSK_COLLECTOR_PATH;
}

/**
 * Para onde a trava manda esta conta, ou `null` quando ela pode ficar onde
 * está. Conta de mesa nunca é desviada; conta de terminal só fica no SEU posto
 * (na bancada, /coletor também desvia; no coletor, /bancada também).
 */
export function KioskLockRedirect(permissions, pathname, width) {
    if (!IsKioskOnlyAccount(permissions)) {
        return null;
    }
    const home = KioskHomePath(width);
    const path = String(pathname || '');
    return path === home || path.startsWith(`${home}/`) ? null : home;
}

/** A rota é a da bancada (onde vale a tela cheia automática)? */
export function IsKioskBenchPath(pathname) {
    const path = String(pathname || '');
    return path === KIOSK_BENCH_PATH || path.startsWith(`${KIOSK_BENCH_PATH}/`);
}
